import axios from '../axios';

/**
 * Coupons API - כל הפונקציות הקשורות לקופונים
 */

export const couponsApi = {
  // קבלת הקופון של המשתמש
  getMyCoupon: async () => {
    try {
      const response = await axios.get('/coupons');
      return response.data;
    } catch (error) {
      console.error('Error fetching coupon:', error);
      throw error;
    }
  },

  // אימות קופון
  validateCoupon: async (code) => {
    try {
      const response = await axios.post('/coupons/validate', { code });
      return response.data;
    } catch (error) {
      console.error('Error validating coupon:', error);
      throw error;
    }
  },

  // קבלת כל הקופונים (admin only)
  getAllCoupons: async () => {
    try {
      const response = await axios.get('/coupons/admin');
      return response.data;
    } catch (error) {
      console.error('Error fetching all coupons:', error);
      throw error;
    }
  },

  // יצירת קופון חדש (admin only)
  createCoupon: async (couponData) => {
    try {
      const response = await axios.post('/coupons/admin', couponData);
      return response.data;
    } catch (error) {
      console.error('Error creating coupon:', error);
      throw error;
    }
  },

  // מחיקת קופון (admin only)
  deleteCoupon: async (couponId) => {
    try {
      const response = await axios.delete(`/coupons/admin/${couponId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting coupon:', error);
      throw error;
    }
  }
};

export default couponsApi; 